import React, { useState } from 'react';
import { Navbar as BSNavbar, Nav, Container, Badge, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTrainingAuth } from '../context/TrainingAuthContext';

const ROLE_LABELS = {
  training_coordinator: 'Training Coordinator',
  training_document_controller: 'Training Doc Controller',
  training_reviewer: 'Training Reviewer',
  training_admin: 'Training Admin',
};

const ROLE_COLORS = {
  training_coordinator: 'primary',
  training_document_controller: 'info',
  training_reviewer: 'warning',
  training_admin: 'danger',
};

const TrainingNavbar = () => {
  const { trainingUser, trainingLogout } = useTrainingAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const handleLogout = () => {
    trainingLogout();
    navigate('/training-login');
  };

  const dashboardPath = () => {
    const role = trainingUser?.role;
    if (['training_coordinator', 'training_document_controller'].includes(role)) {
      return '/training/coordinator';
    }
    return '/training/reviewer';
  };

  return (
    <BSNavbar bg="success" variant="dark" expand="lg" expanded={expanded}
      onToggle={setExpanded} className="shadow-sm">
      <Container fluid>
        <BSNavbar.Brand
          onClick={() => navigate(dashboardPath())}
          style={{ cursor: 'pointer' }}
          className="fw-bold"
        >
          <i className="fas fa-graduation-cap me-2"></i>
          Training System
        </BSNavbar.Brand>

        <BSNavbar.Toggle />

        <BSNavbar.Collapse>
          <Nav className="me-auto">
            <Nav.Link onClick={() => { navigate(dashboardPath()); setExpanded(false); }}>
              <i className="fas fa-tachometer-alt me-1"></i>Dashboard
            </Nav.Link>
            {['training_coordinator', 'training_document_controller'].includes(trainingUser?.role) && (
              <Nav.Link onClick={() => { navigate('/training/new'); setExpanded(false); }}>
                <i className="fas fa-plus-circle me-1"></i>New Certificate
              </Nav.Link>
            )}
          </Nav>

          <Nav className="align-items-center">
            {trainingUser && (
              <Dropdown align="end">
                <Dropdown.Toggle variant="success" className="border-0 d-flex align-items-center gap-2">
                  <i className="fas fa-user-circle fa-lg"></i>
                  <span className="d-none d-md-inline">{trainingUser.full_name}</span>
                  <Badge bg={ROLE_COLORS[trainingUser.role] || 'secondary'} className="ms-1">
                    {ROLE_LABELS[trainingUser.role] || trainingUser.role}
                  </Badge>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Header>
                    <div><small className="text-muted">Role:</small> {ROLE_LABELS[trainingUser.role] || trainingUser.role}</div>
                    <div><small className="text-muted">Email:</small> {trainingUser.email}</div>
                    <div><small className="text-muted">Emp Code:</small> {trainingUser.emp_code}</div>
                  </Dropdown.Header>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => { navigate('/training/profile'); setExpanded(false); }}>
                    <i className="fas fa-user-edit me-2"></i>Edit Profile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => { navigate('/training/change-password'); setExpanded(false); }}>
                    <i className="fas fa-key me-2"></i>Change Password
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout} className="text-danger">
                    <i className="fas fa-sign-out-alt me-2"></i>Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Nav>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
};

export default TrainingNavbar;
